module.exports = __webpack_public_path__ + "img/64.efb60573.png";